

import { Tabs, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { useIsMobile } from '@/hooks/use-mobile';

interface PlanTypeTabsProps {
  activeTab: 'templates' | 'myPlans';
  onTabChange: (tab: 'templates' | 'myPlans') => void;
}

export function PlanTypeTabs({ activeTab, onTabChange }: PlanTypeTabsProps) {
  const isMobile = useIsMobile();
  
  return (
    <Tabs 
      value={activeTab} 
      onValueChange={(value) => onTabChange(value as 'templates' | 'myPlans')} 
      className={isMobile ? "w-[200px]" : "w-[250px]"}
    >
      <TabsList className="grid w-full grid-cols-2">
        <TabsTrigger value="templates">Templates</TabsTrigger>
        <TabsTrigger value="myPlans">My Plans</TabsTrigger>
      </TabsList>
    </Tabs>
  );
}
